import React, { useContext, useEffect, useState } from 'react';
import {
    Modal, ModalHeader, ModalBody, Form, Row, Col,
    FormGroup, Label, Input, Button
} from 'reactstrap';
import Select from 'react-select';
import { AuthContext } from '../../context/AuthContext';
import { ProdutoContext } from '../../context/ProdutoContext';
import { CreateProdutoType } from '../../context/hooks/useProduto';
import { CurrencyInput } from '../Form/CurrencyInput';

interface Props {
    isOpen: boolean;
    toggle: () => void;
    onCreated?: () => void;
}

export const CreateProdutoModal: React.FC<Props> = ({ isOpen, toggle, onCreated }) => {
    const { objUserTk } = useContext(AuthContext);
    const { createProduto } = useContext(ProdutoContext);

    const [form, setForm] = useState<CreateProdutoType>({
        name: '',
        description: '',
        value: 0,
        empresaId: objUserTk?.EmpresaId || 0,
    });

    useEffect(() => {
        if (isOpen) {
            setForm({
                name: '',
                description: '',
                value: 0,
                empresaId: objUserTk?.EmpresaId || 0,
            });
        }
    }, [isOpen]);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const ok = await createProduto({
            ...form,
        });
        if (ok) {
            onCreated?.();
            toggle();
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg">
            <ModalHeader toggle={toggle}>Adicionar novo produto</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Nome</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="name"
                                    value={form.name}
                                    onChange={onChange}
                                    placeholder="Nome do produto"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Descrição</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="textarea"
                                    name="description"
                                    value={form.description}
                                    onChange={onChange}
                                    placeholder="Descrição do produto"
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Valor</Label>
                                <CurrencyInput
                                    name="value"
                                    value={form.value ?? 0}
                                    onValueChange={v => setForm(prev => ({ ...prev, value: v }))}
                                    placeholder="R$ 0,00"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <div className="d-flex justify-content-end mt-3">
                        <Button style={{ background: '#585858', color: '#fff' }} type="submit">Criar produto</Button>
                        <Button style={{ background: '#585858', color: '#fff' }} className="ml-2" onClick={toggle}>Cancelar</Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};
export default CreateProdutoModal;